module.exports = __webpack_public_path__ + "static/media/xiniu_02_icon.312217e5.png";